import React from "react";

const WBOACReqAccess = () => {
  return <div>WBOACReqAccess WBOACReqAccess</div>;
};

export default WBOACReqAccess;
